export default __webpack_public_path__ + "static/media/logo6.272e23e5.svg";